import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeBody-3'],
    fontWeight: typography['lineHeightBody-4'],
    color: colors.primaryText,
  },
  menuContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['size-4'],
  },
  menuTitle: {
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography['lineHeightCaption-1'],
    color: colors.accentText,
  },
  menu: {
    display: 'flex',
    flexDirection: 'column',
    padding: anatomy['size-4'],
    borderRadius: anatomy.borderRadiusS,
    border: `1px solid ${colors.tertiaryBorder}`,
    backgroundColor: colors.primaryBackground,
    width: '280px',
  },
  menuItem: {
    padding: `${anatomy['size-8']} ${anatomy['size-12']}`,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    borderRadius: anatomy.borderRadiusXs,
    ':hover': {
      backgroundColor: colors.hoverBackground,
    },
    width: '100%',
    textAlign: 'left',
  },
  menuItemSelected: {
    backgroundColor: colors.hoverBackground,
  },
});
